export const menu = {
    label: 'FE 2024',
    icon: 'pi pi-calendar',
    to: '/checkins/inscricoes/atendimento',
    rules: ['CHECKINS-INSCRICOES-02'],
};

export default menu;
